
import { ref, defineComponent } from 'vue';

export default defineComponent({
  name: 'TooltipCustom',
  props: {
    value: {
      required: true,
      type: String,
    },
    width: {
      required: false,
      type: Number,
      default: 16,
    },
  },
  setup(props: any) {
    const calcWidth = ref(`TooltipCustom_tooltip_w_${props.width}`);
    (() => {
      if (props.width % 4 !== 0) {
        calcWidth.value = 'TooltipCustom_tooltip_w_16';
      }
    })();

    // TODO: take prop for diagonal cardinality (e.g. top-right, bottom-left), onMount -> get position of slot, move relative of slot position

    return {
      calcWidth,
    };
  },
});
